import { Subject } from 'rxjs/Subject';
var DraggableHelper = /** @class */ (function () {
    function DraggableHelper() {
        this.currentDrag = new Subject();
    }
    return DraggableHelper;
}());
export { DraggableHelper };
//# sourceMappingURL=draggable-helper.provider.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/angular-draggable-droppable/dist/esm/src/draggable-helper.provider.js
// module id = ../../../../angular-draggable-droppable/dist/esm/src/draggable-helper.provider.js
// module chunks = vendor